import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, LogOut, Box} from "lucide-react"; // Import Box (Archive) and BarChart3 (Reports)
import { useAuth } from '../components/AuthContext';
import SafewingsLogo from '../assets/safewings_logo.png'; 


const Layout = ({ children }) => {
    const location = useLocation();
    const { user, logout } = useAuth();

    // Utility function for consistent link styling and active state checking
    const NavLink = ({ to, icon: Icon, children }) => (
        <Link 
            to={to}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition duration-150 ${
                location.pathname.startsWith(to) && to !== '/' // Handles customers/view/*
                    ? "bg-black text-white"
                    : location.pathname === to 
                    ? "bg-black text-white" 
                    : "text-gray-700 hover:bg-gray-100"
            }`}
        >
            <Icon size={25} /> {children}
        </Link>
    );

    return (
        <div className="flex min-h-screen bg-gray-50">
            {/* 1. SIDEBAR: ADD print:hidden */}
            <aside className="w-64 bg-white border-r shadow-sm flex flex-col print:hidden">
                <div className="px-6 py-4 border-b">
                    {/* LOGO INTEGRATION */}
                    <Link to="/dashboard" className="flex items-center">
                        <img 
                            src={SafewingsLogo} 
                            alt="Safewings Insurance Logo" 
                            className="h-150 w-auto" // Corrected size: h-10 w-auto is usually better
                        />
                    </Link>
                </div>
                
                <nav className="flex-1 p-4 space-y-2">
                    
                    {/* Dashboard */}
                    <NavLink to="/dashboard" icon={LayoutDashboard}>
                        Dashboard
                    </NavLink>

                    {/* Customers (List) */}
                    <NavLink to="/customers" icon={Users}>
                        Customers
                    </NavLink>
                    
                    {/* ✅ NEW: Archived Records */}
                    <NavLink to="/archive" icon={Box}>
                        Archived Records
                    </NavLink>                    
                </nav>
                
                {/* User Info / Settings */}
                <div className="p-4 border-t">
                    <p className="text-sm font-semibold text-gray-800">{user?.username || 'User'}</p>
                    <p className="text-xs text-gray-500">Agent Status: Online</p>
                </div>
            </aside>

            {/* 2. PAGE CONTENT AREA: ADD print:w-full to expand content on print */}
            <div className="flex-1 flex flex-col overflow-hidden print:w-full">
                
                {/* TOP HEADER BAR: ADD print:hidden */}
                <header className="px-8 py-3 bg-white border-b shadow-sm flex justify-end items-center print:hidden">
                    <div className="flex items-center space-x-4">
                        
                        <div className="h-4 w-px bg-gray-300"></div> {/* Separator */}

                        {/* Logout Button */}
                        <button
                            onClick={logout}
                            className="flex items-center gap-1 text-red-500 hover:text-red-700 font-medium transition"
                        >
                            <LogOut size={20} /> {/* Reduced size for better header fit */}
                            Logout
                        </button>
                    </div>
                </header>

                {/* Main page content (children) */}
                <main className="flex-1 p-8 overflow-y-auto">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;